import React from 'react';
import './index.scss';
import { Layout } from 'antd';
import { BaiduMap, FooterView } from '../Components';
import { ApplyForm } from '../Partners/Partners';

const { Content } = Layout;

const Contact = () => {
  return (
    <Layout className="layout">
      <div className="layout-header"></div>
      <Content className="about_main">
        {/* <ApplyForm /> */}

        <div className="ContactUs">
          <div className="title-weight" style={{ marginBottom: 50 }}>
            {/* <div className="title-ch">联系我们</div>
            <div className="title-en">CONTACT US</div> */}
            {/* <div className="horizontal-line" /> */}
          </div>
          <div className="ContactUs-bottom">
            <div className="seek-advice-from">
              <div className="advice-ding"></div>
              <div className="eighty-five">
                <p>产品咨询</p>
                <p>产品演示、产品试用、产品报价</p>
              </div>
              <div className="contact">
                <a style={{ color: '#fff' }} href="tel:022-8528-8908">
                  <span>座机号 ：（022）8528 8908</span>
                </a>
                <span>邮&emsp;箱 ： sales@zhiyunshuke.com</span>
              </div>
            </div>

            <div className="cooperate">
              <div className="cooperate-ding"></div>
              <div className="eighty-five">
                <p>市场合作</p>
                <p>市场合作、生态合作</p>
              </div>
            </div>
          </div>
        </div>
        <div className="certificate">
          <div className="map">
            <BaiduMap></BaiduMap>
          </div>
        </div>
      </Content>
      <FooterView></FooterView>
    </Layout>
  );
};

export default Contact;
